import React from 'react';
import Particles from 'react-tsparticles';
import './MainParticles.css';
// import { loadFull } from "tsparticles";

function MainParticles() {

  const particlesInit = async (main:any) => {
    console.log(main);

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    // await loadFull(main);
  };

  const particlesLoaded = (container:any) => {
    console.log(container);
  };

  return (
    <div className='particles'>
         <Particles id="tsparticles"
          // init={particlesInit}
          // loaded={particlesLoaded}
        options={{
        // background: {
        //   color: {
        //     value: "#0d47a1",
        //   },
        // },
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "attract",
            },
            onHover: {
              enable: true,
              mode: "connect",
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 420,
              duration: 10,
              opacity: 0.2,
              size: 5,
            },
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 50,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#35add8",
          },
          links: {
            color: "#fff",
            distance: 100,
            enable: true,
            opacity: 0.04,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: 0.5,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 800,
            },
            value: 80,
          },
          opacity: {
            value: 0.2,
          },
          shape: {
            type: "circle",
          },
          size: {
            random: true,
            value: 2,
          },
        },
        detectRetina: true,
      }}
    />
    </div>
  )
}

export default MainParticles